<template>
  <div class="component-container">

    <div class="second-edition" id="second-edition">
      <h3>2ENG Second Edition: Changing Earth: Today and Over Time - Downloads and Resources</h3>
    
      <div class="back-button-wrapper">
        <button type="button" @click.prevent="cancelButton" class="back-button">Back to Main Dashboard</button>
      </div>

      <div class="presentations">
        <h4>Teacher Resources</h4>
        <ul>
          <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-online-prototype.appspot.com/o/activityPresentations%2FAugust%202025%20Updates%2F2ENG-2E_Activties1-7_updated_08242026.zip?alt=media&token=59a279a6-0137-455f-87af-15f6a11ae3e0" target="_blank">Teacher Presentations: Activities 1 - 7</a> - Updated 8/24/2026</li>
          <li><a href="https://docs.google.com/spreadsheets/d/1RZrQWEcgAu2kxE60cdaDCwpFOj35RFvl_ZiPRYWxAXw/edit?usp=sharing" target="_blank">Teacher Guide Links Spreadsheet</a> - List of all links in the printed Teacher Guide</li>
          <li><a href="https://docs.google.com/spreadsheets/d/1qe8R8GD92WO6dtzWri9pKbKWjAYx2siuRzdE8bcT_6c/edit?gid=1062009112#gid=1062009112">Curriculum Updates Spreadsheet </a> - List with links to updates for your printed Teacher Guide</li>
        </ul>
      </div>

      <div class="presentations">
        <h4>Student Journals &amp; Assessments</h4>
        <p>Please make a master copy and save to your Google drive for your classroom.</p>
        <ul>
          <li><a href="https://docs.google.com/presentation/d/1qf8o0JxYYwUmA7ZgdbPrglGzwOB0E9Kgb5lcPb4MqV8/copy" target="_blank">2ENG Second Edition: Changing Earth: Today and Over Time - Student Journal</a></li>
          <li><a href="https://drive.google.com/file/d/19jOWhScL52aHFerTXXVJ_iGQ8ROlj1G8/view" target="_blank">2ENG Second Edition: Changing Earth: Today and Over Time - Student Journal Answer Key</a></li>
          <li><a href="https://docs.google.com/presentation/d/1KbyYs0v1UZk60PpCNUqxIyDHBTu6ge7DBbMpPdoKGuU/copy" target="_blank">2ENG Second Edition: Changing Earth: Today and Over Time - Student Journal - SPANISH</a></li>
        </ul>
        <ul>
          <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-dev-926a6.appspot.com/o/unitUpdates%2F2ENG-2E_PostAssessment_01312022.pdf?alt=media&token=9a5d5ea3-3990-4753-b00e-38631643a0ec" target="_blank">2ENG Second Edition Post Assessment - Updated 5/31/2022</a></li>
          <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-dev-926a6.appspot.com/o/unitUpdates%2F2ENG-2E_PostAssessment_Spanish_05312022.pdf?alt=media&token=08f6f52c-53a8-4cae-9159-efd478d5fdb5" target="_blank">2ENG Second Edition Post Assessment (Spanish) - Updated 5/31/2022</a></li>
        </ul>
      </div>
      <div class="presentations">
        <h4>Individual Resources</h4>
        <p>The resources below are also linked in the Teacher Led Presentations. We've provided them here for anyone wishing to have access to these individual resources outside of the presentations. Please make master copies and save in your Google drive for your classroom.</p>
        <h4 style="margin-left: 10px;">Charts, Handouts, Card Sets, etc.</h4>
        <ul>
          <li><a href="https://docs.google.com/presentation/d/1ztYoVD9zk3ECClMx_yHD5nvJBSIRqNWI_O_m-9Qrhqc/copy" target="_blank">Weathering Card Set</a></li>
          <li><a href="https://docs.google.com/presentation/d/1t_W6rrJyS5LapygrxJCh6Zx0Oxlw3aIFisgAdgRvU-w/copy" target="_blank">What We Think Chart</a></li>
          <li><a href="https://docs.google.com/spreadsheets/d/1c5JrTB7_ywzOhqOfqF7CXjO5Lo3yEewpKypzRMx9dfY/copy" target="_blank">Globe Toss Spreadsheet with Graphs</a></li>
          <li><a href="https://docs.google.com/presentation/d/1cPjfJCV1s-u1L9qAB1mEHap61qs4zJX4IuDvpm5oJkY/copy" target="_blank">Earth from Space</a></li>
          <li><a href="https://docs.google.com/presentation/d/1r2vnmQOAOpLcJOYj65injRr1oiCe3GDj4PfqdszMEic/copy" target="_blank">US Topographic Map</a></li>
          <li><a href="https://docs.google.com/presentation/d/1ctOcqhqpfm8bu1q1eS49DLKes5prN5iupNvpGivuIy4/copy" target="_blank">John Wesley Powell's Journey</a></li>
          <li><a href="https://docs.google.com/presentation/d/1sssYPDJuZqITNdqH0SHiQTZVBCKdicgMKLR0xNuuob4/copy" target="_blank">2ENG Word Wall</a></li>
          <li><a href="https://docs.google.com/presentation/d/1TsMA16NBKO3PDbLnBdUwlKyMrXdnFxMyDOIgWHGB1Ho/copy" target="_blank">Regional Plant and Animal Card Set</a></li>
          <li><a href="https://docs.google.com/presentation/d/1vbs9aZjsAafGIMKx4s4yrtZbR4blh8Wm7M8GVeJJlfg/copy" target="_blank">Landform Card Set</a></li>
          <li><a href="https://docs.google.com/presentation/d/1cYme9Qw008O4yfSJnNB50A7vl5CI8ryGUMXx7_tsDBs/copy" target="_blank">Word Sort Cards - Lesson 3C</a></li>
          <li><a href="https://docs.google.com/presentation/d/1wWUmwHro_R315trI9ZnzWNcFv8CioJvM1FXBqOnqnog/copy" target="_blank">Landform Card Set with US Topo Map</a></li>
          <li><a href="https://docs.google.com/presentation/d/19UiAeec1xA1K9e3vj1pUnotvEUpfe5MVWX_b-kQl948/copy" target="_blank">Landform Cards, Plant and Animal Cards, US Topo Map</a></li>
          <li><a href="https://docs.google.com/presentation/d/1Zx7Lpskgm0bUCkrWuVPxXCE8pFVssRFudn6wR1CbIRw/copy" target="_blank">Bodies of Water Card Set</a></li>
          <li><a href="https://docs.google.com/presentation/d/1vGyhDA_Jth68vYd-_Mji478Mi9nULVB_VsF_6eiRhR0/copy" target="_blank">Bodies of Water Model Product Descriptor</a></li>
          <li><a href="https://docs.google.com/presentation/d/1bjsC0HsLu-oaw3A7HX4LBUuouBWjv8ASAny8DR5kGWo/copy" target="_blank">Compare Bodies of Water</a></li>
          <li><a href="https://docs.google.com/presentation/d/1j9yeaskJhhHMP-WC9pIfbkhJODpxMDGzuvFT5aFWXgU/copy" target="_blank">Word Sort Cards - Lesson 4C</a></li>
          <li><a href="https://docs.google.com/presentation/d/1pwpEj0DybL-YB1xty7ejDooTH1Irss28oRScpgeP93Q/copy" target="_blank">Liquid Water and Solid Water</a></li>
          <li><a href="https://docs.google.com/presentation/d/17H4MjuWPazdRvNZz9B93TwP1JQMe4L4KSst7sU387Ps/copy" target="_blank">Snow and Ice on the Move Product Descriptor</a></li>
          <li><a href="https://docs.google.com/presentation/d/1dcoakDcwjUOcE5a0FFIjl24pW8m6dfzsTT1M_-It16M/copy" target="_blank">Word Sort Cards - Lesson 6A</a></li>
          <li><a href="https://docs.google.com/presentation/d/1jxZ9HgtH7WpMdE63jMZzEtg_a1M5_5O7xAJYvVKsvXo/copy" target="_blank">Reducing or Preventing Change on the Hillside (Handout)</a></li>
          
          <!-- <li><a href="" target="_blank"></a></li> -->
        </ul>
      </div>
    </div>
  </div>
  </template>

  <script>
  import { mapState } from 'vuex'

  export default {
  data() {
    return {}
  },
  computed: {
    ...mapState([ 'dashboardView', 'userProfile' ])
  },
  methods: {
    cancelButton() {
      this.$store.commit('SET_DASHBOARD_VIEW', 'units')
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  }
  }
  </script>

  <style lang="css" scoped>
  .presentations {
  border: 1px solid grey;
  text-align: left;
  padding: 20px;
  margin: 0 20px 20px 20px;
  }
  ul {
  list-style: none;
  }
  .presentations a {
  margin-left: 40px;
  }
  li {
  margin-left: -40px;
  }
  .back-button-wrapper {
  width: 100%;
  text-align: left;
  margin-bottom: 0;
  }
  .back-button {
  background: white;
  border: none;
  font-weight: 600;
  color: #7b8a1d;
  margin-left: 20px;
  }
  </style>
